<template>
  <form-item>
    <checkbox
      v-if="withAndroidProd"
      :class="{
        'checkbox-btn': true,
        'checkbox-btn-active': model.android_push_production
      }"
      :title="$t('CampaignForm_Segment_ChoosePushEnv_AndroidProduction')"
      :description="
        $t('CampaignForm_Segment_ChoosePushEnv_AndroidProduction_Description')
      "
      v-model="model.android_push_production"
      data-qa="android-production-app-checkbox"
    />
    <checkbox
      v-if="withAndroidLegacy"
      :class="{
        'checkbox-btn': true,
        'checkbox-btn-active': model.android_push_legacy
      }"
      :title="$t('CampaignForm_Segment_ChoosePushEnv_AndroidLegacy')"
      :description="
        $t('CampaignForm_Segment_ChoosePushEnv_AndroidLegacy_Description')
      "
      v-model="model.android_push_legacy"
      data-qa="android-legacy-app-checkbox"
    />
    <checkbox
      v-if="withIosProd"
      :class="{
        'checkbox-btn': true,
        'checkbox-btn-active': model.ios_push_production
      }"
      :title="$t('CampaignForm_Segment_ChoosePushEnv_IosProduction')"
      :description="
        $t('CampaignForm_Segment_ChoosePushEnv_IosProduction_Description')
      "
      v-model="model.ios_push_production"
      data-qa="ios-production-app-checkbox"
    />
    <checkbox
      v-if="withIosSandbox"
      :class="{
        'checkbox-btn': true,
        'checkbox-btn-active': model.ios_push_sandbox
      }"
      :title="$t('CampaignForm_Segment_ChoosePushEnv_IosSandbox')"
      :description="
        $t('CampaignForm_Segment_ChoosePushEnv_IosSandbox_Description')
      "
      v-model="model.ios_push_sandbox"
      data-qa="ios-sandbox-app-checkbox"
    />
    <checkbox
      v-if="withIosLegacy"
      :class="{
        'checkbox-btn': true,
        'checkbox-btn-active': model.ios_push_legacy
      }"
      :title="$t('CampaignForm_Segment_ChoosePushEnv_IosLegacy')"
      :description="
        $t('CampaignForm_Segment_ChoosePushEnv_IosLegacy_Description')
      "
      v-model="model.ios_push_legacy"
      data-qa="ios-legacy-app-checkbox"
    />
  </form-item>
</template>

<script>
import FormItem from '@/common/components/form/FormItem'
import Checkbox from '@/common/components/form/Checkbox'
export default {
  name: 'ChoosePushEnvironments',
  components: {
    Checkbox,
    FormItem
  },
  props: {
    model: {
      type: Object,
      required: true
    },
    withAndroidProd: {
      type: Boolean,
      default: false
    },
    withAndroidLegacy: {
      type: Boolean,
      default: false
    },
    withIosProd: {
      type: Boolean,
      default: false
    },
    withIosSandbox: {
      type: Boolean,
      default: false
    },
    withIosLegacy: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
>>> .el-form-item__content {
  display: flex;
}

.checkbox-btn {
  margin-right: 10px;
  width: 330px;
  border-radius: 4px;
  border: 1px solid #dbdee7;
  padding: 15px;
  margin-bottom: 10px;
}

.checkbox-btn-active {
  border: 1px solid #1d87c8;
  background-color: #e6f3fb;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/segment/ChoosePushEnvironments.vue